import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay }} className={className}>
    {children}
  </motion.div>
);

export const PageHero = ({ eyebrow, title, subtitle, testId = "page-hero" }) => (
  <section className="relative overflow-hidden border-b border-[var(--line)] bg-[var(--paper)] pattern-arch" data-testid={testId}>
    <div className="container-x py-14 md:py-20">
      <Reveal>
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[var(--ink)]">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-base md:text-lg text-[var(--muted-ink)] leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);

export const SectionTitle = ({ eyebrow, title, action }) => (
  <div className="flex items-end justify-between gap-4 mb-10">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-[var(--ink)]">{title}</h2>
    </div>
    {action}
  </div>
);

export const Empty = ({ text, testId = "empty-state" }) => (
  <div className="card-lux p-10 text-center text-[var(--muted-ink)]" data-testid={testId}>{text}</div>
);

export const Spinner = () => (
  <div className="flex justify-center py-16" data-testid="loading-spinner">
    <div className="w-10 h-10 rounded-full border-4 border-[var(--line)] border-t-[var(--copper)] animate-spin" />
  </div>
);
